import PageHeader from '../../../components/PageHeader';

const PrintingMaterialsPage = () => (
  <div className="printing-materials-page">
    <PageHeader title="PRINTING MATERIALS" />
    <p className="printing-materials-page__hint">Business cards, stickers, postcards, and flyers — coming soon.</p>
  </div>
);

export default PrintingMaterialsPage;
